import session from "../../../services/session";
import swal from "sweetalert2";
import AdminApi from '../../../services/api'
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi();
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            id: 0,
            categories: [],
            additionalTypes: [],
            showMemberShipForProgram: CONFIG_COMPANY.SHOW_MEMBERSHIP_FOR_PROGRAMS != null ? CONFIG_COMPANY.SHOW_MEMBERSHIP_FOR_PROGRAMS : false,
            paymentTypes: {
                STANDARD: {
                    id: 1,
                    label: LocService.t('label_standard_payment'),
                    value: false
                },
                ADDITIONAL_SERVICE: {
                    id: 2,
                    label: LocService.t('label_additional_payment'),
                    value: true
                },
            },
            membershipTypes: [
                {
                    id: 'SUBSCRIPTION',
                    label: LocService.t('label_membership_subscription'),
                },
                {
                    id: 'ONE_TIME_PAYMENT',
                    label: LocService.t('label_membership_one_payment'),
                },
                {
                    id: 'ONE_TIME_PAYMENT_AND_SUBSCRIPTION',
                    label: LocService.t('label_membership_both'),
                }
            ],
            showMembershipType: false,
            model: {
                orderNumber: 0,
                name: '',
                category: null,
                durationInDays: 1,
                trainingNumber: 0,
                price: 0,
                additionalKit: null,
                types: [],
                additionalService: false,
                enableAction: false,
                forProgram: false,
                membershipType: null
            },
            kits: [],
            allKits: [],
            types: [],
        }
    },
    methods: {
        openAddMembershipCategory: openAddMembershipCategory,
        getMembershipsCategories: getMembershipsCategories,
        getChipTypeClass: getChipTypeClass,
        isSelectedType: isSelectedType,
        editMembership: editMembership,
        loadMembership: loadMembership,
        openAdditionalKit: openAdditionalKit,
        openTrainingTypes: openTrainingTypes,
        formatDate: formatDate,
        generateKits: generateKits,
        getTrainingTypes: getTrainingTypes,
        detectIfSomeTypeNotExistAnyMore: detectIfSomeTypeNotExistAnyMore,
        getAdditionalKits: getAdditionalKits,
        onChangeCheckBox: onChangeCheckBox,
        onChangeCheckBoxKits: onChangeCheckBoxKits,
        setSelectedCheckBoxKits: setSelectedCheckBoxKits,
        setSelectedCheckBox: setSelectedCheckBox
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        if(session.getConfig().additionalServiceTypes != null && session.getConfig().additionalServiceTypes.length > 0){
            this.additionalTypes = session.getConfig().additionalServiceTypes.split(";").filter(e => e.length > 0)
        }

        if(session.getConfig().enableSubscriptionModel != null){
            this.showMembershipType = session.getConfig().enableSubscriptionModel;
        }
        this.id = this.$route.query.id;
        this.getAdditionalKits();
        this.loadMembership();
        this.getMembershipsCategories();
    }
}

function generateKits(){
    if(this.kits.length === 0) return '';
    var i = 0;
    var kit = '';
    for(i = 0; i < this.kits.length; i++){
        kit = kit + this.kits[i] + ';'
    }
    return kit;
}

function editMembership() {
    let _self = this;
    if(_self.model.types.length === 0){
        swal(LocService.t('label_error'), LocService.t('label_payment_error_choose_type'), 'error')
        return;
    }
    _self.model.id = _self.id;
    _self.model.additionalKit = this.generateKits();
    _self.model.durationInDays = parseInt(_self.model.durationInDays)
    _self.model.trainingNumber = parseInt(_self.model.trainingNumber)
    AdminApiService.updateMembership(_self.model)
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_payment_success_edit'), 'success')
            this.$router.back()
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function loadMembership() {
    let _self = this;
    AdminApiService.getMembershipById(this.id)
        .then((response) => {
            _self.model = response.data
            _self.model.types = response.data.trainingTypes.split(',')
            var kits = response.data.additionalKit != null ? response.data.additionalKit.split(";") : [];
            var i = 0;
            for(i = 0; i < kits.length; i++){
                if(kits[i].length > 0){
                    _self.kits.push(kits[i])
                }
            }
            _self.getTrainingTypes();
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function detectIfSomeTypeNotExistAnyMore(){
    var newModels = [];
    this.model.types.forEach(e => {
        if(this.types[e] != null){
            newModels.push(e)
        }
    })
    this.model.types = newModels;
}


function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.types = response.data
            _self.detectIfSomeTypeNotExistAnyMore();
        })
        .catch(error => {
            console.log(error);
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function setSelectedCheckBox(key) {
    return this.model.types.indexOf(key) > -1
}

function onChangeCheckBox(key) {
    let isChecked = document.getElementById(key).checked
    if(isChecked){
        if(this.model.types.indexOf(key) < 0){
            this.model.types.push(key);
        }
    }else{
        const index = this.model.types.indexOf(key);
        if (index > -1) {
            this.model.types.splice(index, 1);
        }
    }
}


function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('YYYY-MM-DD')
}

function getAdditionalKits(){
    let _self = this;
    AdminApiService.getAdditionalKit()
        .then((response) => {
            _self.allKits = response.data;
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function onChangeCheckBoxKits(key) {
    let isChecked = document.getElementById(key).checked
    if(isChecked){
        if(this.kits.indexOf(key) < 0){
            this.kits.push(key);
        }
    }else{
        const index = this.kits.indexOf(key);
        if (index > -1) {
            this.kits.splice(index, 1);
        }
    }
}

function setSelectedCheckBoxKits(key) {
    return this.kits.indexOf(key) > -1
}

function openAdditionalKit(){
    this.$router.push('additional-kits')
}

function openTrainingTypes(){
    this.$router.push('training-types')
}

function openAddMembershipCategory(){
    this.$router.push('add-membership-category')
}

function getMembershipsCategories(){
    let _self = this;
    AdminApiService.getMembershipsCategories()
        .then((response) => {
            _self.categories = response.data;
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getChipTypeClass(item){
    if(this.model.additionalService === item.value) return 'chip-selected';
    return 'chip-unselected';
}

function isSelectedType(item){
    return this.model.additionalService === item.value;
}




// WEBPACK FOOTER //
// ./src/components/Membership/EditMembership/EditMembership.js